import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import Select from 'react-select';
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import Pagination from '../pagination/pagination';
import { FaSave, FaAngleLeft } from "react-icons/fa";
import { IoAddSharp } from "react-icons/io5";
import { IoSearch } from "react-icons/io5";

const OneReceipt = () => {
    const [precision, setPrecision] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [PaymentTab, setPaymentTab] = useState(true);

    const handleBackClick = () => {
        window.history.back();
    };
    return (
        <div className='p-5'>
            <div className='d-flex justify-contant-between'>
                <h5 className='col mainInvHead'>Lease One Receipt</h5>
                <div className='d-flex justify-content-end gap-1'>
                    <button className='mainbtn ' type="submit"><FaSave className='center mt-1 mx-2' /> <div>Save</div></button>
                    <button className='mainbtnRed'><RiRefreshLine className='center mt-1 mx-2' /><div>Reset</div></button>
                    <button onClick={handleBackClick} className='mainbtnSecondary'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className="cost-center-section mt-3">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}>
                    <div className='h6 pt-1'>Account Details</div>
                </div>
                <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))', gap: '20px' }}>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Acc. Code</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-75 p-0"
                                />
                            </div> <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Receipt Type</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-75 p-0"
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Ref NO</label>
                                <input type="text" className="p-2 form-control w-75" name="leaseTerm" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-75 p-0"
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Receipt Date</label>
                                <input type="Date" className="p-2 form-control w-75" name="periodfrom" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Narration</label>
                                <input type="email" className="p-2 form-control w-75" name="periodto" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No</label>
                                <input type="text" className="p-2 form-control w-75" name="transDate" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Property</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-75 p-0"
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Installment</label>
                                <input type="text" className="p-2 form-control w-75" name="transDate" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Email Id</label>
                                <input type="text" className="p-2 form-control w-75" name="transDate" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Unit No</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-75 p-0"
                                />
                            </div>
                            <div className="d-flex">

                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Vat Reg NO</label>
                                <input type="text" className="p-2 form-control w-75" name="transDate" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Lease No</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-75 p-0"
                                />
                            </div>
                            <div className='d-flex center gap-4'>
                                <div className='mainbtn flex-end gap-2 w-50'>
                                    <IoAddSharp color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>Add</div>
                                </div>
                                <div className='mainbtnGry flex-end gap-2 w-50'>
                                    <IoSearch color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>Search</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section mt-3">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setPaymentTab(!PaymentTab)}>
                    <div className='h6 pt-1'>Debit Details</div>
                </div>
                <div className={`slide-content ${PaymentTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${PaymentTab ? 'slide-in' : 'slide-out'}`}>
                        <div className='table-container' style={{ overflowX: 'auto', height: "auto" }}>
                            <table>
                                <thead className='dynoTable'>
                                    <tr>
                                        <th>Id</th>
                                        <th>Payment Method</th>
                                        <th>Cheque No</th>
                                        <th>Cheque Date</th>
                                        <th>Draawn Bank</th>
                                        <th>Amount</th>
                                        <th>Debit Ac Code</th>
                                        <th>Debit Ac Name</th>
                                        <th>Ref No</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* {Array.isArray(dataList) && dataList?.map((data, index) => ( */}
                                    <tr>
                                        <td className='m-0 p-0'><input className='p-1' style={{ width: "170px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' style={{ width: "170px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' style={{ width: "170px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' style={{ width: "170px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' style={{ width: "170px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' style={{ width: "170px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' style={{ width: "170px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' style={{ width: "170px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' style={{ width: "150px" }} /></td>
                                    </tr>
                                    {/* ))} */}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className='border-box2 p-3'>
                <div className='row'>
                    <div className='col-6'>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start w-25">Total Amount</label>
                            <input type="text" className="p-2 form-control w-50" name="leaseTerm" />
                        </div>
                        <div className="d-flex my-3">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start w-25">Allocated Amount</label>
                            <input type="text" className="p-2 form-control w-50" name="leaseTerm" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start w-25">Unallocated Amount</label>
                            <input type="text" className="p-2 form-control w-50" name="leaseTerm" />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className='d-flex gap-2'>
                            <div style={{ color: '#1032E7', textDecoration: 'underline' }}> Allocate Extra Amount </div>
                            <div >[If any difference in Total and Allocated Amount]</div>
                        </div>
                        <div className="d-flex my-3 gap-3">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start w-25">Account</label>
                            <Select
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                className="w-50 p-0"
                            />
                        </div>
                        <div className="">
                            <div className="d-flex gap-3">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start w-25">Amount</label>
                                <input type="text" className="p-2 form-control w-50" name="leaseTerm" />
                                <button className='mainbtnRed'><RiRefreshLine className='center mt-2 mx-2' /><div className='mt-1'>Reset</div></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default OneReceipt;